var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{},[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return _c('v-breadcrumbs-item',{attrs:{"exact":"","to":item.href,"disabled":_vm.showLink(item.href)}},[_vm._v(" "+_vm._s(item.name)+" ")])}}])}),_c('ContactContent')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }